import { Flex, Icon } from "@chakra-ui/react";
import { ArrowLeft } from "lucide-react";

const CloseModalArrow = ({ onClose }) => {
  return <Flex _hover={{ bg: "grey.100" }} h={"32px"} w={"32px"} borderRadius={"full"} justifyContent={"center"} alignItems={"center"} transition={"all 0.2s ease-in-out"} ><Icon as={ArrowLeft} size={24} onClick={onClose} cursor={"pointer"} /></Flex>;
};

export default CloseModalArrow;
